import { format } from 'date-fns/format'

import { dateFormat } from '../../../constants/dateFormat'

export const formatShortDate = (date: Date) => format(date, dateFormat.shortPublicDate)
